<div [ngClass]="{'tile_disable':disable}" class="tile-container d-flex flex-column align-items-center justify-content-between py-3" (click)="navigate()">
    <img width="60" height="60" class="align-self-center" [src]="icon"/>
    <p class="px-1">{{title}}</p>
</div>
